import { useOptionName as useName } from "@/components/features/items/edit/option/_shared/ui/components/name/hooks/use-name";

import { useProductOptionFormModelContext } from "../../../../context";

export const useOptionName = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();
	const { name } = viewModel;

	return useName({ name, onSetViewModel });
};
